(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity-react/views/terms-integrity.js') >= 0) return;  svs.modules.push('/modules/terms-integrity-react/views/terms-integrity.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.terms_integrity_react=_svs.terms_integrity_react||{};
_svs.terms_integrity_react.templates=_svs.terms_integrity_react.templates||{};
svs.terms_integrity_react.templates.terms_integrity = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<main class=\"f-content js-react-container\"></main>\n";
},"useData":true});
Handlebars.partials['svs-terms_integrity_react-terms_integrity'] = svs.terms_integrity_react.templates.terms_integrity;
})(svs, Handlebars);


 })(window);